'use client';

import { twMerge } from 'utilities/src/twMerge';
import React, { ReactNode, RefObject } from 'react';
import { useAccordionState } from './AccordionProvider';

export enum IndicatorPositionEnum {
  left = 'left',
  right = 'right',
}

type IndicatorPosition = `${IndicatorPositionEnum}`;

export enum JustifyEnum {
  between = 'between',
  start = 'start',
  end = 'end',
}

type Justify = `${JustifyEnum}`;

export type AccordionTitleProps = {
  children: React.ReactNode;
  indicatorExpanded?: ReactNode;
  indicatorCollapsed?: ReactNode;
  indicatorPosition?: IndicatorPosition;
  justify?: Justify;
  classes?: string;
  reference?: RefObject<HTMLInputElement | null>;
  openClasses?: string;
  closedClasses?: string;
};

function AccordionTitle({
  children,
  indicatorExpanded,
  indicatorCollapsed,
  indicatorPosition = IndicatorPositionEnum.left,
  justify = JustifyEnum.start,
  classes = '',
  reference,
  openClasses = '',
  closedClasses = '',
}: AccordionTitleProps) {
  const { open, setOpen } = useAccordionState();
  const hasIcon = indicatorExpanded && indicatorCollapsed;

  const justifyContent = `justify-${justify}`;

  return (
    <div
      ref={reference}
      className={twMerge(
        'flex w-full cursor-pointer flex-row items-center',
        justifyContent,
        { 'flex-row-reverse': indicatorPosition === 'right' },
        classes,
        { [closedClasses]: !open },
        { [openClasses]: open },
      )}
      role="button"
      tabIndex={0}
      onClick={() => setOpen(!open)}
      onKeyDown={() => setOpen(!open)}
    >
      {hasIcon && <span>{open ? indicatorExpanded : indicatorCollapsed}</span>}
      {children}
    </div>
  );
}

export default AccordionTitle;
